export default function EmailVerification() { return <div>Email Verification</div>; }
